import React from 'react';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {
  withSystem,
  Plugins,
  Atom,
  AtomRenderProps,
} from '@packages/systems/wfdl';
import {TListOfElement, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {findChild, getInPojo, getTag} from '@packages/utilities/data-utils';
import {isSearchResultItem} from '@packages/utilities/elementTypeUtils';

const SearchResultList = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    renderChild,
    context,
    data,
  }: AtomRenderProps) => {
    // The tag field is always present via the field's schema default.
    const Tag = getTag(getInPojo(data, ['tag'])) as React.ElementType;
    const edges = context.get('edges', []);
    const searchResultItem = findChild(data, isSearchResultItem);
    const listClasses = classes.push('search-result-items');

    return edges.length > 0 ? (
      <Tag {...generateAttributes(attributes, listClasses)}>
        {/* @ts-expect-error - TS7006 - Parameter 'edge' implicitly has an 'any' type. | TS7006 - Parameter 'itemIndex' implicitly has an 'any' type. */}
        {edges.map((edge, itemIndex) =>
          renderChild(
            searchResultItem,
            context.set('item', edge.node),
            edge.cursor,
            itemIndex
          )
        )}
      </Tag>
    ) : null;
  }
);

const config = createIntegratedAtom({
  displayName: 'Search Result List',
  constraints: {
    pinToParent: true,
    ancestors: [
      {
        is: ['SearchResultWrapper'],
        name: 'Form',
        rule: 'ExactlyOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Search'), iconName('SearchResults')),
  },
  showEmpty: true,
  uiStateOnSelected: 'default',
  render: SearchResultList,
  fields: {
    tag: withSystem(
      {
        label: 'Tag',
        private: true,
        defaultValue: 'div',
      },
      TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
    ),
    children: TListOfElement,
  },
});

export default config;
